import { MdSchedule, MdPlayArrow, MdOutlineMoreHoriz, MdCheckCircle, MdError } from 'react-icons/md';
import { ProcessStatus } from '../../../codegen/graphql';

export { getStatusIcon, getStatusBadge, formatDate, getDuration };

const getStatusIcon = (status: ProcessStatus) => {
  switch (status) {
    case 'pending':
      return <MdSchedule className="text-gray-500" size={20} />;
    case 'started':
      return <MdPlayArrow className="text-blue-500" size={20} />;
    case 'partial':
      return <MdOutlineMoreHoriz className="text-yellow-500" size={20} />;
    case 'success':
      return <MdCheckCircle className="text-green-500" size={20} />;
    case 'error':
      return <MdError className="text-red-500" size={20} />;
  }
};

const getStatusBadge = (status: ProcessStatus) => {
  const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
  switch (status) {
    case 'pending':
      return <span className={`${baseClasses} bg-gray-100 text-gray-800`}>Pending</span>;
    case 'started':
      return <span className={`${baseClasses} bg-blue-100 text-blue-800`}>Started</span>;
    case 'partial':
      return <span className={`${baseClasses} bg-yellow-100 text-yellow-800`}>Partial</span>;
    case 'success':
      return <span className={`${baseClasses} bg-green-100 text-green-800`}>Success</span>;
    case 'error':
      return <span className={`${baseClasses} bg-red-100 text-red-800`}>Error</span>;
  }
};

const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const getDuration = (startedAt?: string | null, completedAt?: string | null) => {
  if (!startedAt) return '-';
  const start = new Date(startedAt).getTime();
  const end = completedAt ? new Date(completedAt).getTime() : Date.now();
  const duration = (end - start);
  
  if (duration < 1000) return `${duration}ms`;
  if (duration < 60000) return `${Math.floor(duration / 1000)}s`;
  if (duration < 3600000) return `${Math.floor(duration / 60000)}m ${Math.floor((duration % 60000) / 1000)}s`;
  return `${Math.floor(duration / 3600000)}h ${Math.floor((duration % 3600000) / 60000)}m ${Math.floor((duration % 60000) / 1000)}s`;
};